import React,{useState} from "react";
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import { CreatePage } from "../db/db";
import { useAlert } from "react-alert";
const NewPage=(props)=>{
    const myAlert = useAlert();
    const [newPage, setNewPAge] = useState(
        {
            id: 1,
            name: "Yeni Sayfa",
            soundUrl: null,
            subtitle: "Alt Başlık",
            author: "Yazar",
            prev: false,
            soundTime: "0",
            QIssueID: props.QIssueID
        }
    )
    return(
        <>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">

                    <Form.Label column sm="6">
                        Sayfa Adı
                    </Form.Label>
                    <Col sm="12">
                        <Form.Control required type="text" placeholder={newPage.name} onChange={(e) => {
                            setNewPAge({ ...newPage, name: e.target.value })

                        }} />
                    </Col>
                    <Form.Label column sm="6">
                        Alt Başlık
                    </Form.Label>
                    <Col sm="12">
                        <Form.Control type="text" placeholder={newPage.subtitle} onChange={(e) => {
                            setNewPAge({ ...newPage, subtitle: e.target.value })

                        }} />
                    </Col>
                    <Form.Label column sm="6">
                        Yazar
                    </Form.Label>
                    <Col sm="12">
                        <Form.Control type="text" placeholder={newPage.author} onChange={(e) => {
                            setNewPAge({ ...newPage, author: e.target.value })

                        }} />
                    </Col>

                    <Form.Label column sm="12">

                    </Form.Label>

                    <Col sm="6">

                        <Button className="btn-secondary" size="sm" active onClick={
                            async () => {

                                const dbData=await CreatePage(newPage)
                                if(dbData=="Ok"){
                                    myAlert.success("Yeni Sayfa Eklendi!")
                                    props.pageLoad()
                                    props.handleClose()
                                }


                            }}>
                            <FaSave /> Yeni Sayfa Ekle
                        </Button>

                    </Col>

                </Form.Group>


            </Form>

        </>
    )
}

export default NewPage